import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config";
import { log } from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

// Create a new todo
export const createTodo = async (token, todoData) => {
    log("welcome in createTodo")

    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/create_todo_api'
        log("url=" + url)

        const result = await axios.post(url, todoData, { headers: headers })
        log("result.data din axios createTodo")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in createTodo")
        log(err)
        error.value = err.message
        return { error: true, message: "Eroare la createTodo" }
    }
}

// Get todos list
export const getTodos = async (token, options = {}) => {
    log("welcome in getTodos")

    if (!token || token === "") {
        return { error: true, message: "No token provided", todos: [] }
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_todos_api'
        log("url=" + url)

        const params = {}
        if (options.view) params.view = options.view
        if (options.status) params.status = options.status
        if (options.app_section_name) params.app_section_name = options.app_section_name
        if (options.include_subclients !== undefined) params.include_subclients = options.include_subclients
        if (options.page) params.page = options.page
        if (options.per_page) params.per_page = options.per_page
        // Additional filters
        if (options.filter_responsible_client_id) params.filter_responsible_client_id = options.filter_responsible_client_id
        if (options.filter_initiator_client_id) params.filter_initiator_client_id = options.filter_initiator_client_id
        if (options.responsible_user_id) params.responsible_user_id = options.responsible_user_id
        // Sorting
        if (options.sort_by) params.sort_by = options.sort_by
        if (options.sort_direction) params.sort_direction = options.sort_direction

        const result = await axios.get(url, { headers: headers, params: params })
        log("result.data din axios getTodos")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getTodos")
        log(err)
        error.value = err.message
        return { error: true, message: "Eroare la getTodos", todos: [] }
    }
}

// Update a todo
export const updateTodo = async (token, todoId, updateData) => {
    log("welcome in updateTodo for id=" + todoId)

    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/update_todo_api'
        log("url=" + url)

        const result = await axios.put(url, { id: todoId, ...updateData }, { headers: headers })
        log("result.data din axios updateTodo")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in updateTodo")
        log(err)
        error.value = err.message
        return { error: true, message: "Eroare la updateTodo" }
    }
}

// Update a step
export const updateStep = async (token, stepId, updateData) => {
    log("welcome in updateStep for id=" + stepId)

    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/update_step_api'
        log("url=" + url)

        const result = await axios.put(url, { id: stepId, ...updateData }, { headers: headers })
        log("result.data din axios updateStep")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in updateStep")
        log(err)
        error.value = err.message
        return { error: true, message: "Eroare la updateStep" }
    }
}

// Get users with todo_responsible role
export const getTodoResponsibleUsers = async (token, includeSubclients = true) => {
    log("welcome in getTodoResponsibleUsers")

    if (!token || token === "") {
        return { error: true, message: "No token provided", users: [] }
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_todo_responsible_users_api'
        log("url=" + url)

        const params = { include_subclients: includeSubclients }

        const result = await axios.get(url, { headers: headers, params: params })
        log("result.data din axios getTodoResponsibleUsers")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getTodoResponsibleUsers")
        log(err)
        error.value = err.message
        return { error: true, message: "Eroare la getTodoResponsibleUsers", users: [] }
    }
}

// Delete a todo
export const deleteTodo = async (token, todoId) => {
    log("welcome in deleteTodo for id=" + todoId)

    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/delete_todo_api'
        log("url=" + url)

        const result = await axios.post(url, { id: todoId }, { headers: headers })
        log("result.data din axios deleteTodo")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in deleteTodo")
        log(err)
        error.value = err.message
        return { error: true, message: "Eroare la deleteTodo" }
    }
}

// Request IMSIs from distributor (specific helper)
export const requestImsisFromDistributor = async (token, options = {}) => {
    log("welcome in requestImsisFromDistributor")

    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/request_imsis_from_distributor_api'
        log("url=" + url)

        const data = {
            quantity: options.quantity || 10,
            imsi_type_name: options.imsi_type_name || 'standard',
            reason: options.reason || 'Stoc epuizat',
            urgency: options.urgency || 2,
            importance: options.importance || 2
        }

        const result = await axios.post(url, data, { headers: headers })
        log("result.data din axios requestImsisFromDistributor")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in requestImsisFromDistributor")
        log(err)
        error.value = err.message
        return { error: true, message: "Eroare la requestImsisFromDistributor" }
    }
}

export default function useTodosAPI() {
    return {
        error,
        createTodo,
        getTodos,
        updateTodo,
        updateStep,
        getTodoResponsibleUsers,
        deleteTodo,
        requestImsisFromDistributor
    }
}
